import React from "react";
import { Modal, Button } from "react-bootstrap";
import { FaExclamationTriangle } from "react-icons/fa";
import "./ConfirmDialog.scss";

interface ConfirmDialogProps {
  show: boolean;
  title?: string;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
  confirmText?: string;
  cancelText?: string;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  show,
  title = "Please Confirm",
  message,
  onConfirm,
  onCancel,
  confirmText = "Yes",
  cancelText = "No",
}) => (
  <Modal
    show={show}
    onHide={onCancel}
    centered
    backdrop="static"
    dialogClassName="confirm-dialog"
  >
    <Modal.Header className="confirm-header" closeButton>
      <FaExclamationTriangle className="me-2 header-icon" />
      <Modal.Title className="header-title">{title}</Modal.Title>
    </Modal.Header>
    <Modal.Body className="confirm-body text-center">
      <p className="message-text">{message}</p>
    </Modal.Body>
    <Modal.Footer className="confirm-footer justify-content-center">
      <Button
        variant="outline-secondary"
        size="lg"
        className="me-3 btn-cancel"
        // className="btn-confirm"
        onClick={onCancel}
      >
        {cancelText}
      </Button>
      <Button
        size="lg"
        className="btn-confirm"
        onClick={onConfirm}
      >
        {confirmText}
      </Button>
    </Modal.Footer>
  </Modal>
);

export default ConfirmDialog;